import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	CollapseComponent,
	EmptyStateComponent,
	InfoGroupComponent,
	ListDetailComponent,
	TagIconComponent,
} from '@tecalisdev/infinity';
import { IOperationEvaluationDetail } from '../../../../../processes/models/processes.models';
import { IOperationDetailResponse, OPERATION_STATUS } from '../../../../models/operations.models';
import { MasterService } from '../../../../../shared/services/master.service';
import { NOT_AVAILABLE_DISPLAY } from '../../../../../core/utils/utils';
import { OperationDetailOperationMetaComponent } from '../../../../../shared/components/operations/common/operation-detail-operation-meta/operation-detail-operation-meta.component';

type FinancialDetailsCollapseSection = 'data' | 'operation';

@Component({
	selector: 'app-operation-detail-tabs-details-financial-evaluation',
	imports: [
		TranslatePipe,
		CollapseComponent,
		EmptyStateComponent,
		ListDetailComponent,
		InfoGroupComponent,
		TagIconComponent,
		OperationDetailOperationMetaComponent,
	],
	templateUrl: './operation-detail-tabs-details-financial-evaluation.component.html',
	styleUrl: './operation-detail-tabs-details-financial-evaluation.component.scss',
})
export class OperationDetailTabsDetailsFinancialEvaluationComponent implements OnChanges {
	@Input() detail: IOperationDetailResponse;

	public masterService = inject(MasterService);

	public evaluationData: IOperationEvaluationDetail | null = null;
	public OPERATION_STATUS = OPERATION_STATUS;
	public expandedCollapseSection: FinancialDetailsCollapseSection | null = 'data';

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['detail']) return;
		this.evaluationData = this.detail?.data ? (this.detail.data as unknown as IOperationEvaluationDetail) : null;
	}

	public toggleCollapse(section: FinancialDetailsCollapseSection, expanded?: boolean): void {
		this.expandedCollapseSection = !expanded ? null : section;
	}

	public get isScoringType(): boolean {
		return this.evaluationData?.scoring !== undefined && this.evaluationData?.scoring !== null;
	}

	public get evaluationTypeLabel(): string {
		const type = this.evaluationData?.type;
		if (!type) return NOT_AVAILABLE_DISPLAY;
		const key = 'FINANCIAL_EVALUATION.' + type;
		return this.masterService.hasTranslation(key) ? key : type;
	}

	public get obtainMethodLabel(): string {
		return this.evaluationData?.mode === 'manual' ? 'PROCESSES.DETAIL.MANUAL' : 'PROCESSES.DETAIL.AUTOMATIC';
	}

	public get totalTriesLabel(): string {
		if (!this.evaluationData) return NOT_AVAILABLE_DISPLAY;
		return this.evaluationData.total_tries === 0
			? '1'
			: (this.evaluationData.total_tries ?? NOT_AVAILABLE_DISPLAY).toString();
	}
}
